import React from 'react';
import styles from './style.module.css';
import { Container } from '../../components';
import * as Icon from '../../components/Icons';
const index = () => {
  return (
    <div className={styles.subscribe}>
      <Container full>
        <div className={styles.container}>
          <div className={styles.text}>
            <Icon.SubscribeAlarm fill={"white"}/>
            <div>
              <h3 className={styles.title}>{'Get Updates & More'}</h3>
              <p className={styles.subTitle}>{'Thoughtful thoughts to your inbox'}</p>
            </div>
          </div>
          <div className={styles.subscribeInputs}>
            <input type="text" placeholder={'Your Email'} className={styles.input}/>
            <button className={styles.button}>{'Subscribe'}</button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default index;
